import React from 'react';

import Navbar from '../components/LandingPageNew/Navbar';

import Footer from '../components/LandingPageNew/Footer';
import QuoteWizard from '../components/RequestQuote/QuoteWizard';
const RequestQuote = () => {
  return (
    <div className="relative min-h-screen">
      {/* Navbar on top of hero */}
      <Navbar />
      <QuoteWizard />
      {/* <LocalListing /> */}
      <Footer/>
    </div>
  );
};

export default RequestQuote;
